import { render, staticRenderFns } from "./navList.vue?vue&type=template&id=138b463a&scoped=true"
import script from "./navList.vue?vue&type=script&lang=js"
export * from "./navList.vue?vue&type=script&lang=js"
import style0 from "./navList.vue?vue&type=style&index=0&id=138b463a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b463a",
  null
  
)

export default component.exports